<div id="account-action"  *ngIf ="actionsList?.length > 0">
    <ng-select
        wcag-label
        [placeholder]="'COMMON.actionsLabel.actions' | translate"
        [inputAttrs]="{'aria-label': 'COMMON.actionsLabel.actions' | translate}"
        [items]="actionsList"
        class="ng-dropdown-left"
        bindLabel="label"
        bindValue="label"
        (change)="triggerActionController($event)"
        [clearable]="false"
        [alignRight]="true"
        [searchWhileComposing]="false"
        [typeToSearchText]="false"
        [appendTo]="appendTo"
        [(ngModel)]="dummyModel">
    </ng-select>
</div>
